<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Parameter_Title' | translateWF: 'Parameters' }}</h1>
        <div class="page__title_buttons">
          @if (canEdit()) {
            <p-button [label]="'Common_Add' | translateWF: 'Add'" icon="pi pi-plus" (click)="openParamModal()" />
          }
        </div>
      </div>
    </div>
    <section>
      <div class="cs-page-list-grid">
        @if (filterConfig() && showFilters()) {
          <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
        }

        <p-panel [header]="'Parameter_Title' | translateWF: 'Parameters'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
              [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
              (click)="showFilters.set(!showFilters())"
              variant="outlined"
              size="small"
            />
          </ng-template>
          <p-card data-variant="compact">
            <p-table [value]="filteredParameters()" [paginator]="true" [rows]="15" selectionMode="single">
              <ng-template pTemplate="header">
                <tr class="primary__header">
                  <th pSortableColumn="name">
                    {{ 'Parameter_Name' | translateWF: 'Name' }}
                    <p-sortIcon field="name" />
                  </th>
                  <th pSortableColumn="friendlyName">
                    {{ 'Parameter_Friendly_Name' | translateWF: 'Friendly Name' }}
                    <p-sortIcon field="friendlyName" />
                  </th>
                  <th pSortableColumn="parameterType">
                    {{ 'Parameter_Type' | translateWF: 'Type' }}
                    <p-sortIcon field="parameterType" />
                  </th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-rowData>
                @let param = getRowData(rowData);
                <tr class="cursor-pointer" (click)="openParamModal(param)">
                  <td class="max-w-[12.5rem] truncate">
                    <a>
                      {{ param.name | localized }}
                    </a>
                  </td>
                  <td>{{ param.friendlyName | localized }}</td>
                  <td>{{ getParameterTypeName(param.parameterType) }}</td>
                </tr>
              </ng-template>
            </p-table>
          </p-card>
        </p-panel>
      </div>
    </section>
  </div>
</main>
